import React, { memo } from "react";
import { BsPatchCheckFill } from "react-icons/bs";
import { useLanguage } from "../../i18n";
import { getProfileLocationLabel } from "../../utils/profileLocation";
import { getProfileImageUrl } from "../../utils/imageUtils";
import "./ProfileGridCard.css";

function getDisplayName(profile) {
  if (profile.displayName) return profile.displayName;
  if (profile.name) {
    return String(profile.name).replace(/,\s*\d+$/, "").trim();
  }
  const title = profile.title ?? "";
  return title.replace(/,\s*\d+$/, "").trim() || title;
}

function isProfileVerified(profile) {
  if (profile.verified === true) return true;
  if (profile.services?.includes("Verified")) return true;
  return false;
}

function ProfileGridCard({ profile, onClick }) {
  const { t } = useLanguage();
  const image = getProfileImageUrl(profile);
  const displayName = getDisplayName(profile);
  const location = getProfileLocationLabel(profile);
  const verified = isProfileVerified(profile);

  return (
    <button
      type="button"
      className="profile-grid-card"
      onClick={() => onClick?.(profile)}
    >
      <div className="profile-grid-card__media">
        {image ? (
          <img
            src={image}
            alt=""
            className="profile-grid-card__image"
            loading="lazy"
            decoding="async"
          />
        ) : (
          <span className="profile-grid-card__fallback" aria-hidden />
        )}
        {verified ? (
          <span className="profile-grid-card__verified" aria-label={t("profile.verified")}>
            <BsPatchCheckFill aria-hidden />
          </span>
        ) : null}
      </div>
      <div className="profile-grid-card__body">
        <p className="profile-grid-card__name">{displayName}</p>
        {location ? (
          <p className="profile-grid-card__location">{location}</p>
        ) : null}
      </div>
    </button>
  );
}

export default memo(ProfileGridCard);
